import { styled } from '../../../../utils/styled';
import { propStyles } from '../../../../utils/propStyles';

const StyledComponent = styled<any, any>(
    'li',
    'documentRecord',
    'documentsGrid'
)`
    ${propStyles};
    padding: 16px 0;
    border-style: none none solid none;
    border-color: #dee2e6;
    border-width: 1px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export default StyledComponent;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentsGrid/StyledComponents/DocumentRecord.tsx